import { useMemo } from 'react';

import JsonLd from '@/components/common/JsonLd';
import Breadcrumb from '@/components/common/Breadcrumb';
import buildLinkedData from '@/linkedData/breadcrumb-lkd';
import { useAppSelector } from '@/redux';
import { getBreadcrumbItems } from '@/utils/breadcrumbUtils';
import { removeEndSlash } from '@/utils/millesimaUtils';
import { formatUrl } from '@/utils/linkUtils';

import styles from './BreadcrumbContainer.module.scss';
import { PAGES } from '@/constants/pages';

type BreadcrumbContainerProps = {
  breadcrumbSeo: string[],
  baseUrl: string;
  isCentered?: boolean;
  homeLabel?: string;
};

export const BreadcrumbContainer = ({
  breadcrumbSeo = [],
  baseUrl,
  homeLabel
}: BreadcrumbContainerProps) => {
  const storeConf = useAppSelector(({ root }) => root.storeConf);

  const breadcrumb = useMemo(() =>
    getBreadcrumbItems([
      { name: homeLabel, url: removeEndSlash(baseUrl) },
      ...breadcrumbSeo
    ])
  , [breadcrumbSeo]);

  const links = breadcrumb.map((link, index) =>
    (link.url === PAGES.BLOG || index === 0) ? ({
      href: link.url,
      label: link.name
    }) : ({
      href: formatUrl(link.url, link.isSpirit, storeConf),
      label: link.name
    })
  );

  const json = useMemo(() => buildLinkedData(baseUrl, breadcrumb), [baseUrl, breadcrumb]);

  return (
    <>
      {json && (
        <JsonLd data={json} />
      )}
      <div className={styles.container}>
        <Breadcrumb links={links}/>
      </div>
    </>
  );
};

export default BreadcrumbContainer;
